import React, { useCallback, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { CommentsSection } from 'src/component/community/comments-section'
import { ReactionButtons } from 'src/component/community/reaction-buttons'
import { PageContainer } from 'src/component/page-container/page-container'
import { BackArrow } from 'src/component/programmes/programme-back-arrow'
import { ProgrammeInfoContainer } from 'src/component/programmes/programme-info-container'
import { ProgressReport } from 'src/component/programmes/programme-progress-report'
import { WorkoutPopup } from 'src/component/programmes/programme-workout-popup'
import { WorkoutsContainer } from 'src/component/programmes/programme-workouts-container'
import { ProgrammeWorkout } from 'src/dao/core-dao'
import {
  useCompletedProgrammeWorkouts,
  useHustlerProgramme,
  useProgrammeWorkout,
  useProgrammeWorkouts,
} from 'src/hook/use-programme-workouts'
import { useProgrammeIntensities } from 'src/hook/use-programmes'

export const ProgrammeOverviewScreen = (): React.ReactElement => {
  const { programmeId } = useParams<{ programmeId: string }>()
  const [showProgressReport, onShowProgressReport] = useState<boolean>(false)
  const [selectedProgrammeWorkout, setSelectedProgrammeWorkout] = useState<ProgrammeWorkout | undefined>(undefined)

  const navigate = useNavigate()

  const handleProgrammeError = useCallback(() => {
    navigate('/programmes')
  }, [navigate])

  const { data: programmeIntensities = [] } = useProgrammeIntensities()
  const { data: hustlerProgramme, isLoading: isLoadingProgramme } = useHustlerProgramme(programmeId || '', {
    onError: handleProgrammeError,
  })
  const { data: programmeWorkouts = [] } = useProgrammeWorkouts(programmeId || '')
  const { data: completedProgrammeWorkouts = [] } = useCompletedProgrammeWorkouts(programmeId || '')

  const { data: selectedWorkout } = useProgrammeWorkout(selectedProgrammeWorkout as ProgrammeWorkout)

  if (!programmeId) {
    return <div>Programme not found</div>
  }

  if (isLoadingProgramme || !hustlerProgramme) {
    return <div>Loading...</div>
  }

  return (
    <PageContainer>
      <div className={'mt-4'}>
        <BackArrow />
        <div className={`p-0 mt-4`}>
          <Row>
            <Col xl={6}>
              <ProgrammeInfoContainer
                showProgressReport={showProgressReport}
                onShowProgressReport={onShowProgressReport}
                hustlerProgramme={hustlerProgramme}
              />
            </Col>
            <Col xl={6}>
              {!showProgressReport ? (
                <WorkoutsContainer
                  selectWorkout={setSelectedProgrammeWorkout}
                  hustlerProgramme={hustlerProgramme}
                  programmeWorkouts={programmeWorkouts}
                  completedProgrammeWorkouts={completedProgrammeWorkouts}
                  programmeIntensities={programmeIntensities}
                />
              ) : (
                <ProgressReport
                  hustlerProgramme={hustlerProgramme}
                  programmeWorkouts={programmeWorkouts}
                  completedProgrammeWorkouts={completedProgrammeWorkouts}
                />
              )}
            </Col>
          </Row>
        </div>
        <div className="mt-6 space-y-4">
          <div className="flex flex-wrap items-center gap-4">
            <ReactionButtons entityId={programmeId} entityType="series" />
          </div>
          <CommentsSection entityId={programmeId} entityType="series" />
        </div>
        <WorkoutPopup
          setOnClose={() => setSelectedProgrammeWorkout(undefined)}
          selectedWorkout={selectedWorkout?.workout}
          startWorkoutLink={
            selectedWorkout
              ? `/programmes/${programmeId}/programme-workouts/${selectedWorkout.id}/workouts/${selectedWorkout.workoutId}`
              : undefined
          }
        />
      </div>
    </PageContainer>
  )
}
